import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack
} from '@mui/material'
import React, { useState } from 'react'

import { AWSMonitorSuccessEvaluation } from 'components/status-checks/form/status-check/aws/AWSMonitorSuccessEvaluation'
import { AWSMonitorURL } from 'components/status-checks/form/status-check/aws/AWSMonitorURL'
import { StatusCheckNameField } from 'components/status-checks/form/status-check/common/StatusCheckNameField'
import { StatusCheckMonitorSelectionRadioValue } from 'components/status-checks/status-checks-form-utils'

export const AWSMonitorSelection: React.FC = () => {
  const [radioValue, setRadioValue] =
    useState<StatusCheckMonitorSelectionRadioValue>(
      StatusCheckMonitorSelectionRadioValue.URL
    )

  return (
    <Stack sx={{ rowGap: 4 }}>
      <StatusCheckNameField />
      <RadioGroup
        data-testid="aws-monitor-selection-radio-group"
        name="monitor-selection"
        sx={{ marginLeft: 1, rowGap: 1 }}
        value={radioValue}
        onChange={(_, value: StatusCheckMonitorSelectionRadioValue) =>
          setRadioValue(value)
        }
      >
        <FormControl>
          <FormControlLabel
            control={<Radio />}
            label="Create a Health Check from an AWS Cloudwatch Alarm URL"
            value={StatusCheckMonitorSelectionRadioValue.URL}
          />
          <Box sx={{ marginLeft: 4 }}>
            {radioValue === StatusCheckMonitorSelectionRadioValue.URL && (
              <AWSMonitorURL />
            )}
          </Box>
        </FormControl>
        <FormControl>
          <FormControlLabel
            control={<Radio />}
            label="Create a Health Check from AWS API"
            value={StatusCheckMonitorSelectionRadioValue.API}
          />
          <Box sx={{ marginLeft: 4 }}>
            {radioValue === StatusCheckMonitorSelectionRadioValue.API && (
              <AWSMonitorSuccessEvaluation />
            )}
          </Box>
        </FormControl>
      </RadioGroup>
    </Stack>
  )
}
